import { Navigate, useParams } from 'react-router';

function AWAWorkspaceRedirect() {
  const { workspaceId } = useParams();

  return <Navigate to={`/${workspaceId}/maintenance`} replace />;
}

export default AWAWorkspaceRedirect;
